var map = {
	"./default_tank.png": 9344,
	"./oldTanks/tank1.png": 8752,
	"./oldTanks/tank2.png": 731,
	"./oldTanks/tank3.png": 5906,
	"./oldTanks/tank4.png": 765,
	"./oldTanks/tank5.png": 6868,
	"./tank1.png": 4025,
	"./tank2.png": 3314,
	"./tank3.png": 7531,
	"./tank4.png": 5876,
	"./tank5.png": 5821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1532;